import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const PrimaryCTA = () => {
  return (
    <Link to="/contact">
      <Button size="lg" className="text-lg px-8 py-6">
        Book a Free Consultation
      </Button>
    </Link>
  );
};

export default PrimaryCTA;
